(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.pdpAccordionReady) return;
    window.pdpAccordionReady = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.accordion-trigger');
      if (!trigger) return;
      var item = trigger.closest('.accordion-item');
      var list = trigger.closest('.accordion-list');
      if (!item || !list) return;
      var willOpen = !item.classList.contains('is-open');
      list.querySelectorAll('.accordion-item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var openTrigger = openItem.querySelector('.accordion-trigger');
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
      });
      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
